import { apiCrm } from '../../../../http';
import { calculateOffsetFromPageAndLimit } from 'views/CRM/shared/utils/pagination';

class ProductService {
  getProducts(recordTypeId, params = {}, headers = { page: 1, limit: 10 }) {
    const offset = calculateOffsetFromPageAndLimit(headers.page, headers.limit);
    return apiCrm.get(`/product/recordType/${recordTypeId}`, {
      params,
      headers: { ...headers, offset }
    });
  }

  getAllProducts() {
    return apiCrm.get(`/all-products`);
  }

  getShowProductsFields(productId) {
    return apiCrm.get(`/show-product-fields/${productId}`);
  }

  create(data) {
    return apiCrm.post(`/product`, data);
  }

  update(productId, data) {
    return apiCrm.put(`product/${productId}`, data);
  }

  getById(id) {
    return apiCrm.get(`product/${id}`);
  }

  async removeAttachment(productId, attachmentId) {
    return apiCrm.delete(`/product-attachment/${productId}/${attachmentId}`);
  }

  async addAttachments(productId, formData) {
    return apiCrm.post(`/product-attachment/${productId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async getExcel(params) {
    return apiCrm.get('/report/product/export/xlsx', {
      params,
      responseType: 'arraybuffer'
    });
  }

  async getCsv(params) {
    return apiCrm.get('/report/product/export/csv', { params });
  }

  async getPdf(params) {
    return apiCrm.get('/report/product/export/pdf', {
      params,
      responseType: 'blob'
    });
  }

  importProducts(recordTypeId, data) {
    return apiCrm.post(`product/${recordTypeId}/import`, data);
  }

  changeProductStatus(productId, status) {
    return apiCrm.put(`product/${productId}/status`, { status });
  }

  getProductChangesHistory(productId) {
    return apiCrm.get(`product-history-changes/${productId}`);
  }
}

export default new ProductService();
